module.exports = __webpack_public_path__ + "static/media/Birra-Moretti-Logo.bac37bfb.png";